import type { FanslyApi } from '../api'
import { accountOf, asList, unwrap } from '../data'
import { chatRowsOf, type ChatRow } from './model'
import { chatsQuery } from './useChatList'

/**
 * One fan's chat when it is not in a loaded list: Fansly's chat search, by
 * @username when the account can be looked up (`byUsername`), else by the id.
 * Used by the Chats page (`?fan=`) and Workspace (ADR 0045).
 */
export async function findChatRow(api: FanslyApi, fanId: string, meId: string, byUsername: boolean): Promise<ChatRow | null> {
  let username = ''
  if (byUsername) {
    const u = unwrap(await api.get('/crm/accounts/by-ids', { ids: fanId }).catch(() => null))
    username = (Array.isArray(u) ? asList(u) : []).map(accountOf).find((a) => a.id === fanId)?.username ?? ''
  }
  for (const term of [username, fanId].filter(Boolean)) {
    const rows = chatRowsOf(await api.get('/crm/chats', chatsQuery('recent', term, 0, 10)), meId)
    const hit = rows.find((r) => r.fanId === fanId)
    if (hit) return hit
  }
  return null
}
